import graphql__c46e0613a07bc53be6ec from "./__generated__/LocaleSwitchFetchRouteWithTargetLocaleQuery.graphql.js";
import graphql__a088874398a8415cdee3 from "./__generated__/LocaleSwitch_platform.graphql.js";import { useCallback, useState } from "react";
import { graphql, useFragment, fetchQuery } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage, useLocale } from "./Intl/Context";
import Button from "./Buttons/Button";
import appRelayEnvironment from "../config/AppRelayEnvironment";
import { publicAssetPath } from "./Utils/publicAssetPath";

const LocaleSwitch = props => {
  const platform = useFragment(LocaleSwitch_platform, props.platform);
  const { publishedLocales, useLocaleNamesInsteadOfFlags } = platform;
  const { withinComplexMenu } = props;

  const locale = useLocale();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const publishedLocalesForDropdown = publishedLocales.filter(loc => loc !== locale);

  const toggleDropdownOpen = useCallback(() => {
    setDropdownOpen(!isDropdownOpen);
  }, [isDropdownOpen]);

  const dropdownClassName = classNames([
    "dropdown-menu",
    "box-shadow",
    { "dropdown-menu-align-right": useLocaleNamesInsteadOfFlags },
    { show: isDropdownOpen }
  ]);

  const t = useFormatMessage();
  const switchLocaleTitle = t(intlMessages.switchLocaleTitle);

  // When the user clicks the target locale, we load from the server the translated target
  // path where we'll redirect him, and update the browser URL through the
  // window.location.href setter ensuring that the browser reloads the page.
  //
  const handleLocaleClick = useCallback(locale => {
    setLoading(true);

    const environment = appRelayEnvironment;
    // We fetch the pathname from the current window.location as the `location` redux
    // store doesn't include the current locale and we need the locale for rails to
    // recognize the path we're providing it.
    const path = window.location.pathname;

    fetchQuery(environment, LocaleSwitchFetchRouteWithTargetLocaleQuery, {
      path,
      locale
    }).subscribe({
      next: ({ routeWithTargetLocale }) => (window.location.href = routeWithTargetLocale)
    });
  }, []);

  // Build the list of locale labels that will be used in the dropdown, and, depending on
  // the useLocaleNamesInsteadOfFlags platform setting, display a flag of the target
  // locale country or an acronym of the locale, like FR, EN etc.
  const localeLabels = publishedLocales.reduce(
    (list, locale) => ({
      ...list,
      [locale]: useLocaleNamesInsteadOfFlags ? (
        locale
      ) : (
        <img
          src={publicAssetPath(`/images/${locale}.jpg`)}
          className="locale-switch-flag"
        />
      )
    }),
    {}
  );

  const buttonClassName = classNames(
    "btn",
    "btn-primary",
    "locale-switch-button",
    "text-uppercase",
    "font-weight-bolder",
    "dropdown-toggle",
    {
      "locale-switch-button-active": isDropdownOpen,
      "btn-sm": withinComplexMenu,
      "d-flex": withinComplexMenu,
      "align-items-center": withinComplexMenu
    }
  );

  return (
    <div className="locale-switch d-flex flex-row position-relative">
      <Button className={buttonClassName} onClick={toggleDropdownOpen}>
        {localeLabels[locale]}

        <span className="caret" />
      </Button>

      <div className={dropdownClassName}>
        {useLocaleNamesInsteadOfFlags && (
          <span className="d-block with-icon-text padding-x-sm padding-y-xs text-legend text-nowrap text-muted bg-light">
            {switchLocaleTitle}
          </span>
        )}

        {publishedLocalesForDropdown.map(publishedLocale => (
          <Button
            key={publishedLocale}
            onClick={() => handleLocaleClick(publishedLocale)}
            label={localeLabels[publishedLocale]}
            className="dropdown-item locale-switch-button btn btn-primary-inverse text-uppercase font-weight-bolder border-bottom"
            disabled={isLoading}
            data-loading={isLoading}
          />
        ))}
      </div>
    </div>
  );
};

const LocaleSwitchFetchRouteWithTargetLocaleQuery = graphql__c46e0613a07bc53be6ec;

const LocaleSwitch_platform = graphql__a088874398a8415cdee3;

export default LocaleSwitch;

const intlMessages = defineMessages({
  switchLocaleTitle: {
    id: "localeSwitch.switchLocaleTitle",
    defaultMessage: "Langue"
  }
});
